// Filter-Toolbar: Search + Tier-Filter + Online-Filter + Stripe-Filter
// + Add-Member-Button. Filter sind controlled — Parent verwaltet State.

import { Plus, Search } from 'lucide-react';
import type { UserTier } from '@/lib/admin-users-api';

export type TierFilter = 'all' | UserTier;
export type OnlineFilter = 'all' | 'online' | 'offline';
export type StripeFilter = 'all' | 'active' | 'inactive';

interface UserToolbarProps {
  query: string;
  onQueryChange: (v: string) => void;
  tier: TierFilter;
  onTierChange: (v: TierFilter) => void;
  online: OnlineFilter;
  onOnlineChange: (v: OnlineFilter) => void;
  stripe: StripeFilter;
  onStripeChange: (v: StripeFilter) => void;
  onAddClick: () => void;
}

export function UserToolbar(props: UserToolbarProps) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-white/5 bg-white/[0.02] p-2">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-2 top-1/2 -translate-y-1/2 size-3.5 text-neutral-500" />
        <input
          type="search"
          value={props.query}
          onChange={(e) => props.onQueryChange(e.target.value)}
          placeholder="Email/Nickname filtern…"
          className="w-full rounded-md border border-white/10 bg-neutral-900/60 pl-7 pr-3 py-1.5 text-[12px] text-neutral-100 outline-none focus:border-amber-500/40"
        />
      </div>
      <FilterSelect value={props.tier} onChange={props.onTierChange} label="Tier">
        <option value="all">Alle Tiers</option>
        <option value="owner">Owner</option>
        <option value="pro">Pro</option>
        <option value="trial">Trial</option>
        <option value="free">Free</option>
      </FilterSelect>
      <FilterSelect value={props.online} onChange={props.onOnlineChange} label="Online">
        <option value="all">Alle</option>
        <option value="online">Online</option>
        <option value="offline">Offline</option>
      </FilterSelect>
      <FilterSelect value={props.stripe} onChange={props.onStripeChange} label="Stripe">
        <option value="all">Alle</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </FilterSelect>
      <button
        type="button"
        onClick={props.onAddClick}
        className="ml-auto inline-flex items-center gap-1 rounded-md border border-amber-500/40 bg-amber-500/15 px-3 py-1.5 text-[12px] font-semibold text-amber-200 hover:bg-amber-500/25"
      >
        <Plus className="size-3.5" />
        Member hinzufügen
      </button>
    </div>
  );
}

function FilterSelect<T extends string>({
  value,
  onChange,
  label,
  children,
}: {
  value: T;
  onChange: (v: T) => void;
  label: string;
  children: React.ReactNode;
}) {
  return (
    <label className="inline-flex items-center gap-1 text-[11px] text-neutral-500">
      <span className="sr-only">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        className="rounded-md border border-white/10 bg-neutral-900/60 px-2 py-1.5 text-[12px] text-neutral-200 outline-none focus:border-amber-500/40"
      >
        {children}
      </select>
    </label>
  );
}
